<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="flex flex-wrap items-center mb-base">
        <img
          :src="
            formData.file !== null
              ? formData.file.includes('upload//')
                ? `${url.baseFl}/${formData.file}`
                : formData.file
              : emptyImage
          "
          alt="kategori-sos-img"
          class="rounded-lg shadow-md cursor-pointer block w-full mb-4"
        />
        <div>
          <input
            type="file"
            class="hidden"
            ref="updateImgInput"
            @change="updateCurrImg"
            accept="image/*"
          />
          <vs-button class="mr-4 sm:mb-0 mb-2" @click="$refs.updateImgInput.click()"
            >Upload Gambar Kategori ZIS</vs-button
          >
          <!-- <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
        </div>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama Kategori</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="category name"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi Dengan Nama Kategori"
        />
        <span class="text-danger text-sm">{{ errors.first("category name") }}</span>
      </div>

      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Deskripsi</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-textarea
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="description"
          class="w-full sidebar-input"
          v-model="formData.description"
          placeholder="Isi Dengan description"
        />
        <span class="text-danger text-sm">{{ errors.first("description") }}</span>
      </div>
      <div class="mb-6 flex justify-between">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Price Custom</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-switch v-model="priceSelect">
          <span slot="on">On</span>
          <span slot="off">Off</span>
        </vs-switch>
      </div>
      <!-- <vs-divider position="center"
        ><span class="text-lg text-black mb-16"
          ><strong>Setting Mobile</strong></span
        ></vs-divider
      >
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Root</strong></h6>
        </section>
        <vs-input
          class="w-full sidebar-input"
          v-model="formData.root"
          placeholder="Isi Dengan Root"
        />
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Icon</strong></h6>
        </section>
        <vs-input
          class="w-full sidebar-input"
          v-model="formData.icon"
          placeholder="Isi Dengan Icon"
        />
      </div> -->
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addWithOption"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      emptyImage,
      url,
      priceSelect: false,
      binaryFile: "",
      formData: {
        file: emptyImage,
        name: "",
        description: "",
        price_custom: 2,
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Kategori ZIS" : "Tambah Kategori ZIS";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.name !== "" &&
        this.formData.description !== "" &&
        this.formData.price_custom !== null
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.file = this.getPathFoto(this.passData);
        this.formData.name = this.passData.name;
        this.formData.description = this.passData.description;
        this.formData.price_custom = this.passData.price_custom;
        this.priceSelect = this.passData.price_custom === 1;
      } else {
        this.resetForm();
      }
    },
    priceSelect() {
      if (this.priceSelect) {
        this.formData.price_custom = 1;
      } else {
        this.formData.price_custom = 2;
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.file = this.emptyImage;
      this.formData.name = "";
      this.formData.description = "";
      this.binaryFile = "";
      this.formData.price_custom = 2;
      this.priceSelect = false;
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file = e.target.result;
          this.binaryFile = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addWithOption() {
      this.$vs.loading({
        color: "primary",
      });
      console.log(this.passData);
      if (this.binaryFile === "") {
        this.addData();
      } else {
        this.addWithFile();
      }
    },
    addWithFile() {
      this.$store
        .dispatch("file/addFile", this.binaryFile)
        .then((v) => {
          this.formData.file = v.link;
          this.addData();
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.binaryFile = "";
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      if (this.formData.file === this.emptyImage) {
        this.formData.file = null;
      }
      this.$store
        .dispatch("zis/cudKatZIS", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Kategori ZIS Sukses!"
                : "Tambah Kategori ZIS Sukses!",
            text:
              this.passData !== null
                ? `Kategori ZIS ${v.name} Berhasil diedit`
                : `Kategori ZIS ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
  },
};
</script>

<style scoped>
.text-red {
  color: red;
}
.text-blue {
  color: blue;
}
.text-grey-black {
  color: rgb(70, 70, 70);
}
img {
  max-height: 400px;
  overflow: auto;
}
</style>
